export default "__VITE_ASSET__Br_6qOrE__"